<template>
  <div class="grid grid-cols-4 gap-2">
    <button
      v-for="year in years"
      :key="year"
      :class="
        selectedYear === year
          ? 'bg-ontick-blue-600'
          : 'bg-ontick-steel-500 filter transition-all hover:brightness-125'
      "
      class="rounded py-1 px-3 font-semibold"
      @click="selectYear(year)"
    >
      {{ year }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    span: {
      type: Number,
      default: 5,
    },
    allowPast: {
      type: Boolean,
      default: true,
    },
    allowFuture: {
      type: Boolean,
      default: true,
    },
    selectedYear: {
      type: Number,
    },
  },

  computed: {
    years() {
      let arr = [];
      if (this.allowPast && this.allowFuture) {
        for (
          let i = this.moment().subtract(this.span, "years").year();
          i < this.moment().add(this.span, "year").year();
          i++
        ) {
          arr.push(i);
        }
        return arr;
      } else if (this.allowPast) {
        for (
          let i = this.moment().subtract(this.span, "years").year();
          i <= this.moment().year();
          i++
        ) {
          arr.push(i);
        }
        return arr;
      } else if (this.allowFuture) {
        for (
          let i = this.moment().year();
          i <= this.moment().add(this.span, "year").year();
          i++
        ) {
          arr.push(i);
        }
        return [...new Set(arr)];
      }
    },
  },

  methods: {
    selectYear(year) {
      this.$emit("select-year", year);
    },
  },
};
</script>

<style></style>
